const ws_prefix = process.env.REACT_APP_WS_URL_PREFIX;
const ws_host = process.env.REACT_APP_WS_URL_HOST;
const ws_port = process.env.REACT_APP_WS_URL_PORT;
const ca_prefix = process.env.REACT_APP_CA_URL_PREFIX;
const ca_authorization = process.env.REACT_APP_CA_URL_AUTHORIZATION;
const ca_getDetails = process.env.REACT_APP_CA_MS_GET_DETAILS;
const ca_getDetailsQuery = process.env.REACT_APP_CA_GET_DETAILS_QUERY_PLACE_ID;

const environment = {
  wsUrl: `${ws_prefix}://${ws_host}:${ws_port}`,
  caUrl: `${ca_prefix}`,
  caAuthorization: ca_authorization,
  caGetDetails: ca_getDetails,
  caGetDetailsQuery: `${ca_getDetails}${ca_getDetailsQuery}`,
};

export default environment;
